<template>
  <v-data-table
    :headers="[
      { value: 'action', sortable: false },
      { text: 'Title', value: 'title' },
      { text: 'Internal Name', value: 'internalName' },
      { text: 'Loan Type', value: 'loanType' },
      { text: 'Discount', value: 'discount' },
      { text: 'Review Score', value: 'scoreAverage' },
      { text: 'Weighted Score', value: 'scoreWeighted' },
      { text: 'Reviews', value: 'reviewCount' },
      { text: 'Deals', value: 'matchCount' },
    ]"
    :items="products"
    :loading="loading"
    sort-by="createdAt"
    group-by="organizationId"
    class="products-table elevation-1"
  >
    <template v-slot:group.header="{ group, headers }">
      <td :colspan="headers.length">
        {{ (!group || !group === 'null') ? 'No Group' : `Organization: ${getGroupName(group)}` }}
      </td>
    </template>

    <template #top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Products</v-toolbar-title>
        <v-divider class="mx-4" inset vertical />
      </v-toolbar>

      <p class="help px-5">
        The ability to edit a product or view detailed stats such a reviews is now all kept within the organization dashboard to ensure consistency. To get to the organization dashboard for a given product, click on the name in the table.
      </p>

      <v-divider class="section-divider condensed" />
    </template>

    <template #item.title="{ item, value }">
      <router-link
        v-if="!!item.organizationId"
        class="default-btn link small"
        :to="{
          name: 'OrganizationProductsEdit',
          params: { organizationId: item.organizationId, productId: item.id }
        }"
      >{{ value }}</router-link>
      <h5 v-else>{{ value }}</h5>
    </template>

    <template #item.discount="{ value, item }">
      <div class="discount-indicator">
        <img v-if="value" :src="discountIcon" />
        <span @click="$emit('updateDiscount', item)">
          {{ value || 'None' }}
        </span>
      </div>
    </template>

    <template #header.scoreWeighted>
      Weighted Score
      <v-tooltip bottom color="black">
        <template v-slot:activator="{ on }">
          <v-icon color="primary" v-on="on">mdi-information</v-icon>
        </template>
        <span>
          This is a computed score not displayed to users. It is calculated based on the review score of a product along with how many reviews they've recieved.
        </span>
      </v-tooltip>
    </template>

    <template #item.scoreWeighted="{ value }">
      {{ value ? value.toFixed(4) : 'N/A' }}
    </template>

    <template v-slot:item.scoreAverage="{ value }">
      {{ value ? value.toFixed(2) : 'N/A' }}
    </template>

    <template v-slot:item.action="{ item }">
      <div class="button-group">
        <button
          class="default-btn text text-red minimal"
          @click="$emit('delete', item)"
        ><v-icon color="inherit">mdi-delete</v-icon></button>

        <button
          v-if="!item.organizationId"
          class="default-btn green small slim"
          @click="$emit('assignToOrganization', item)"
        >Add to Organization</button>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import DiscountIcon from '@/modules/shared/assets/discount_icon.png'

export default {
  name: 'AdminProductsTable',
  props: {
    products: Array,
    organizations: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    discountIcon: DiscountIcon,
  }),

  methods: {
    getGroupName (id) {
      return (
        this.organizations.find(group => group.id === id) ||
        { name: '' }
      ).name
    },
  },
}
</script>

<style lang="scss" scoped>
.discount-indicator {
  display: flex;
  align-items: center;

  span {
    padding: 0 5px;

    display: inline-block;
    cursor: pointer;

    border-bottom: 2px solid rgba($inputBorderColorFilled, 0.5);

    color: $inputBorderColorFilled;
    font-family: "Sansation Bold", sans-serif;
    font-size: 10px;
  }

  img {
    width: 30px;
    clip-path: polygon(50% 0%, 100% 50%, 50% 80%, 0% 50%);
  }
}

.button-group {
  justify-content: flex-start;
}

::v-deep {
  .v-row-group__header td {
    height: 32px !important;
    vertical-align: middle !important;
  }
}
</style>
